var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reading)?_c('div',[_c('qrcode-stream',{on:{"decode":_vm.onDecode}}),_vm._v(" "),_c('qrcode-drop-zone')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }